import { useState, useEffect } from 'react';
import { decodeStorage, encodeStorage } from 'functions/storageBase64';
import getUserProfile from 'services/UserProfile';

const getCookieValue = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

export const useSessionValidator = () => {
    const [isValidating, setIsValidating] = useState(false);
    const [isValid, setIsValid] = useState(null);

    const syncAndValidate = async () => {
        setIsValidating(true);
        
        const accessToken = getCookieValue('access_token');
        const refreshToken = getCookieValue('refresh_token');
        let synced = false;

        if (accessToken && !decodeStorage('access_token')) {
            encodeStorage('access_token', accessToken);
            synced = true;
        }
        if (refreshToken && !decodeStorage('refresh_token')) {
            encodeStorage('refresh_token', refreshToken);
            synced = true;
        }
        if (accessToken && !decodeStorage('session_token')) {
            encodeStorage('session_token', accessToken);
            synced = true;
        }

        if (synced) {
            try {
                const profileResponse = await getUserProfile();
                if (profileResponse.statusCode === 200) {
                    setIsValid(true);
                } else if (profileResponse.statusCode === 401) {
                    setIsValid(false);
                } else {
                    setIsValid(true);
                }
            } catch (error) {
                setIsValid(true);
            }
        } else {
            setIsValid(true);
        }
        
        setIsValidating(false);
    };

    return { isValidating, isValid, syncAndValidate };
};

export default useSessionValidator;
